const { Utils } = require("./ms-utilities");
const { Request } = require("./ms-request");
const AccessToken = require("./ms-access-token");
const RefreshToken = require("./ms-refresh-token");

const Service = function (configure) {
  this.configure = configure;
  this.refreshToken = null;
  this.accessToken = null;

  this.setRefreshToken = function (refreshToken) {
    this.refreshToken = refreshToken;
  };

  this.setAccessToken = function (accessToken) {
    this.accessToken = accessToken;
  };

  this.login = function (phone) {
    return new Promise((resolve, reject) => {
      const headers = { app_secret: this.configure.appSecret };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.login(sandBox) + `/${phone}`;
      Request.get(url, headers)
        .then((response) => {
          const message = response.data.message;
          if (this.configure.sandBox) {
            const code = response.data.verify_code;
            resolve({ message, code });
          } else {
            resolve(message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.verify = function (phone, verify_code) {
    return new Promise((resolve, reject) => {
      const data = { phone, verify_code };
      const headers = { app_secret: this.configure.appSecret };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.verify(sandBox);
      Request.post(url, data, headers)
        .then((response) => {
          const accessToken = response.data.access_token;
          const refreshToken = response.data.refresh_token;
          const expire = response.data.expire;
          this.accessToken = new AccessToken(accessToken, expire);
          this.refreshToken = new RefreshToken(refreshToken);
          resolve({
            accessToken: this.accessToken,
            refreshToken: this.refreshToken,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.loginMySabay = function (username, password) {
    return new Promise((resolve, reject) => {
      const headers = { app_secret: this.configure.appSecret };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.loginMySabay(sandBox);
      const data = { username, password };
      Request.post(url, data, headers)
        .then((response) => {
          const accessToken = response.access_token;
          const refreshToken = response.refresh_token;
          const expire = response.expire;
          this.accessToken = new AccessToken(accessToken, expire);
          this.refreshToken = new RefreshToken(refreshToken);
          resolve({
            accessToken: this.accessToken,
            refreshToken: this.refreshToken,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.fetchProfile = function () {
    return new Promise((resolve, reject) => {
      const headers = {
        Authorization: "Bearer " + this.accessToken.tokenString,
        app_secret: this.configure.appSecret,
      };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.profile(sandBox);
      Request.get(url, headers)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.refreshTokens = function () {
    return new Promise((resolve, reject) => {
      const data = { refresh_token: this.refreshToken.tokenString };
      const headers = { app_secret: this.configure.appSecret };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.refreshToken(sandBox);
      Request.post(url, data, headers)
        .then((response) => {
          const accessToken = response.data.access_token;
          const refreshToken = response.data.refresh_token;
          const expire = response.data.expire;
          this.accessToken = new AccessToken(accessToken, expire);
          this.refreshToken = new RefreshToken(refreshToken);
          resolve({
            accessToken: this.accessToken,
            refreshToken: this.refreshToken,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.verifyToken = function () {
    return new Promise((resolve, reject) => {
      const headers = {
        Authorization: "Bearer " + this.accessToken.tokenString,
        app_secret: this.configure.appSecret,
      };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.verifyToken(sandBox);
      Request.get(url, headers)
        .then((response) => {
          resolve(200 === response.status);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.storeItems = function () {
    return new Promise((resolve, reject) => {
      const headers = {
        Authorization: "Bearer " + this.accessToken.tokenString,
        app_secret: this.configure.appSecret,
      };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.storeItems(sandBox);
      Request.get(url, headers)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.getProviders = function (packageCode, platform) {
    return new Promise((resolve, reject) => {
      const headers = {
        Authorization: "Bearer " + this.accessToken.tokenString,
        app_secret: this.configure.appSecret,
      };
      const sandBox = this.configure.sandBox;
      const url =
        Utils.endPoint.preAuthProviders(sandBox) +
        `?package_code=${packageCode}` +
        `${platform ? "&platform=" + platform : ""}`;
      Request.get(url, headers)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.payWithPreAuthProvider = function (
    uuid,
    amount,
    pspCode,
    pspAssetCode,
    packageCode
  ) {
    return new Promise((resolve, reject) => {
      const data = {
        uuid: uuid,
        amount: amount,
        psp_code: pspCode,
        psp_asset_code: pspAssetCode,
        package_code: packageCode,
      };
      const headers = {
        Authorization: "Bearer " + this.accessToken.tokenString,
        app_secret: this.configure.appSecret,
      };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.payPreAuthProviders(sandBox);
      Request.post(url, data, headers)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.requestOneTimePaymentPayload = function (
    uuid,
    amount,
    pspCode,
    pspAssetCode,
    packageCode
  ) {
    return new Promise((resolve, reject) => {
      const data = {
        uuid: uuid,
        amount: amount,
        psp_code: pspCode,
        psp_asset_code: pspAssetCode,
        package_code: packageCode,
      };
      const headers = {
        Authorization: "Bearer " + this.accessToken.tokenString,
        app_secret: this.configure.appSecret,
      };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.requestOneTimePayment(sandBox);
      Request.post(url, data, headers)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  this.logout = function (all = false) {
    return new Promise((resolve, reject) => {
      const data = { refresh_token: this.refreshToken.tokenString };
      const headers = { app_secret: this.configure.appSecret };
      const sandBox = this.configure.sandBox;
      const url = Utils.endPoint.logout(sandBox) + `?all=${all}`;
      Request.del(url, data, headers)
        .then((response) => {
          this.accessToken = null;
          this.refreshToken = null;
          resolve({ message: "Logout successfully!" });
        })
        .catch((error) => {
          this.accessToken = null;
          this.refreshToken = null;
          reject(error);
        });
    });
  };
};

module.exports = Service;
